export default "__VITE_ASSET__BoKqGjGH__"